// Vars
var $containerReposList = $('#containerReposList');
var $addToListButton = $('#addToListButton');
var $addToListInput = $('#addToListInput');

// Local Store
var localStore = {
  repos: []
};

function updateLocalList() {
  // Check for LS data
  var repos = localStorage.getItem('repos');

  if (repos && repos.length > 0) {
    var reposParsed = JSON.parse(repos);

    // Update local list
    localStore.repos = [...reposParsed];
  }
}

function updateLocalStorage() {
  // Format data for LS
  var formatedData = JSON.stringify(localStore.repos);

  // Add to LS
  localStorage.setItem('repos', formatedData);
}

function addToList(url) {
  // Format data
  var slug = url.split('https://github.com/')[1];

  var formatedItem = {
    id: Date.now(),
    slug,
    url
  };

  // Check for existing
  if (localStore.repos.find(el => el.url == url)) {
    return;
  }

  // Add to local list
  localStore.repos = [...localStore.repos, formatedItem];

  // Update LS
  updateLocalStorage();
}

function removeFromList(id) {
  // Remove from local list
  var updatedRepos = localStore.repos.filter(item => item.id != id);

  // Update local list
  localStore.repos = [...updatedRepos];

  // Update LS
  updateLocalStorage();
}

function listItems() {
  var containerReposListContent;

  // Check for items
  if (localStore.repos.length > 0) {
    var reposListItems = localStore.repos
      .map(
        item =>
          `<li class="d-flex justify-content-between align-items-center mb-4">
            <span>${item.url}</span>
            <i class="fas fa-times text-danger js-remove-item cursor-pointer" data-id="${item.id}"></i>
          </li>`
      )
      .join('');

    var reposList = `<ul>${reposListItems}</ul>`;

    containerReposListContent = reposList;
  } else {
    containerReposListContent = `<p class="text-center">No repos</p>`;
  }

  if ($containerReposList.length > 0) {
    $containerReposList.html(containerReposListContent);
  }
}

// Handlers
function handleListItemRemoveClick() {
  var $this = $(this);
  var id = $this.data('id');

  removeFromList(id);

  listItems();
}

function handleAddToListButtonClick() {
  var inputValue = $addToListInput.val().trim();
  var isValuValid = inputValue.split('https://github.com/').length == 2;

  if (inputValue == '' || !isValuValid) {
    return;
  }

  addToList(inputValue);

  listItems();

  $addToListInput.val('');
}

$(document).ready(function() {
  updateLocalList();

  listItems();

  $containerReposList.on('click', '.js-remove-item', handleListItemRemoveClick);
  $addToListButton.on('click', handleAddToListButtonClick);
});
